module.exports = __webpack_public_path__ + "static/media/4.43292fc5.png";